import { GuidePriority } from "../guide";
import type { GuideContext, GuideStep } from "../guide";

/**
 * Captain Bram on supplies (MP-06): the first time the player holds one and the battle card shows it, one line on the
 * wells — once per save, target required (the card's supplies row while something is held), so it never speaks about
 * wells that are not there. On the lobby only, after the first session.
 */

export const SuppliesTargets = {
  heldRow: ".hub .battlecard .prebattle .suprow.held",
} as const;

/** Hub feature tips wait for the first session to be over (scripts/features.ts HubTipsFromCleared). */
const FROM_CLEARED = 2;
const TIP = { kind: "tip", block: "none", needsTarget: true } as const;
const lobby = (c: GuideContext): boolean => c.screen === "hub" && c.hub !== null && c.hub.sheet === null && c.hub.highestCleared >= FROM_CLEARED;

export const suppliesHubSteps: readonly GuideStep[] = [
  { ...TIP, id: "hub.supplies", screen: "hub", pose: "pointing", priority: GuidePriority.NewThing, topic: "supplies",
    target: { dom: SuppliesTargets.heldRow },
    text: "You've got **supplies**! Tap one here to take it into your next battle, where it's used up.",
    when: lobby },
];
